var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 154,
    viewBox: "0 0 240 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4184_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.189 15.8217C102.189 15.8217 77.794 -2.22568 53.4072 0.229585C29.0203 2.68485 4.38086 34.1296 4.38086 34.1296L12.2756 40.1138C12.2756 40.1138 53.194 6.16643 75.3546 31.2638C97.5151 56.3612 102.189 15.8217 102.189 15.8217Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.189 15.8217C102.189 15.8217 77.794 -2.22568 53.4072 0.229585C29.0203 2.68485 4.38086 34.1296 4.38086 34.1296L12.2756 40.1138C12.2756 40.1138 53.194 6.16643 75.3546 31.2638C97.5151 56.3612 102.189 15.8217 102.189 15.8217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7632 13.3035H0V67.4219H83.7632V13.3035Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M219.331 128.302C217.788 127.992 216.333 127.344 215.073 126.406C213.812 125.467 212.778 124.262 212.044 122.876V122.798L174.663 52L154.089 66.4862L168.639 111.978C169.022 113.174 169.109 114.445 168.892 115.682C168.675 116.918 168.16 118.084 167.391 119.08C166.622 120.076 165.623 120.872 164.478 121.401C163.333 121.929 162.076 122.174 160.815 122.115C149.762 121.612 138.007 121.33 125.794 121.33C62.6993 121.33 11.5493 128.639 11.5493 137.661C11.5493 146.682 62.6993 154 125.794 154C188.889 154 239.999 146.69 239.999 137.684C239.999 134.183 232.349 130.956 219.331 128.302Z",
    fill: "#C9D3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.453 132.917C100.453 132.917 101.622 136.864 105.088 137.33C108.553 137.795 109.28 141.277 106.098 141.988C102.916 142.698 95.0454 138.238 95.0454 138.238L95.5428 133.224L100.453 132.917Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9767 132.245C32.9767 132.245 28.9661 133.114 28.2398 136.532C27.5135 139.951 23.9925 140.409 23.503 137.18C23.0135 133.951 28.0898 126.458 28.0898 126.458L33.0477 127.351L32.9767 132.245Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5132 73.3035C33.5132 73.3035 29.8185 90.5456 43.1211 97.935C56.4237 105.325 98.3843 92.0219 91.9027 133.903H101.266C101.266 133.903 113.368 99.1666 81.9711 86.8193L72.4421 76.0114L33.5132 73.3035Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.69 60.858L159.505 57.8145L139.586 78.6587L142.771 81.7023L162.69 60.858Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M162.69 60.858L159.505 57.8145L139.586 78.6587L142.771 81.7023L162.69 60.858Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.138 59.3655L157.954 56.322L138.034 77.1663L141.219 80.2098L161.138 59.3655Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.802 63.2011C174.923 57.8423 176.176 50.7289 172.602 47.3129C169.027 43.8969 161.978 45.4719 156.857 50.8307C151.736 56.1895 150.482 63.3029 154.057 66.7189C157.632 70.1349 164.681 68.5599 169.802 63.2011Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M169.802 63.2011C174.923 57.8423 176.176 50.7289 172.602 47.3129C169.027 43.8969 161.978 45.4719 156.857 50.8307C151.736 56.1895 150.482 63.3029 154.057 66.7189C157.632 70.1349 164.681 68.5599 169.802 63.2011Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.247 61.7209C173.368 56.3621 174.622 49.2487 171.047 45.8327C167.472 42.4167 160.423 43.9917 155.302 49.3505C150.181 54.7093 148.928 61.8227 152.502 65.2387C156.077 68.6547 163.126 67.0797 168.247 61.7209Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M166.049 59.621C169.432 56.0811 170.261 51.3823 167.899 49.126C165.538 46.8698 160.882 47.9105 157.499 51.4504C154.116 54.9904 153.288 59.6892 155.649 61.9454C158.01 64.2016 162.666 63.161 166.049 59.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.197 17.7715C135.197 17.7715 131.636 22.9426 128.178 25.4847C127.843 25.729 127.463 25.9048 127.059 26.0021C126.656 26.0994 126.237 26.1163 125.828 26.0518C125.418 25.9873 125.025 25.8426 124.671 25.6261C124.317 25.4096 124.009 25.1255 123.765 24.79C122.51 23.0294 121.325 20.2821 122.897 17.2821L124.933 11.8584C125.461 10.8217 126.297 9.97388 127.326 9.43111C128.355 8.88834 129.527 8.67725 130.681 8.8268C134.999 9.07943 137.518 14.7321 135.197 17.7715Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.181 12.9717L110.115 19.4454L112.088 30.8769L123.67 21.4269L126.181 12.9717Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.832 16.9821C132.287 15.8053 130.883 14.4543 129.647 12.9558C129.536 13.9707 129.13 14.931 128.481 15.719C127.832 16.507 126.967 17.0887 125.992 17.3927C125.053 17.702 124.035 17.675 123.113 17.3164C122.191 16.9578 121.423 16.2898 120.939 15.4269L126.15 9.26898C126.862 8.35773 127.808 7.65635 128.886 7.23934C129.965 6.82232 131.136 6.70525 132.276 6.90056C133.261 7.07018 134.234 7.30223 135.189 7.5953C137.558 8.38477 139.208 11.7164 141.813 11.8269C142.075 11.8397 142.329 11.9203 142.551 12.0607C142.772 12.2012 142.954 12.3967 143.077 12.6283C143.2 12.8598 143.261 13.1193 143.254 13.3816C143.247 13.6438 143.172 13.8997 143.037 14.1242C141.758 16.2479 138.963 18.9479 135.545 17.8664C134.929 17.6678 134.35 17.3691 133.832 16.9821Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.631 17.677C126.631 17.677 128.131 15.7823 126.631 14.7639C125.131 13.7454 122.928 16.477 124.626 18.3007L126.631 17.677Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.789 20.9141L132.6 23.8904C132.584 24.057 132.527 24.217 132.434 24.3561C132.341 24.4951 132.214 24.6089 132.067 24.6872C131.919 24.7654 131.754 24.8057 131.586 24.8045C131.419 24.8032 131.254 24.7604 131.108 24.6799L128.968 23.4956L132.789 20.9141Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M122.369 22.4767C122.369 22.4767 122.85 18.8846 124.145 17.5188C124.145 17.5188 118.295 19.4925 118.161 25.9267L122.369 22.4767Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M16.3101 66.0246C16.3101 66.0246 16.0575 28.7851 60.789 20.9141L34.5075 67.422H16.3496L16.3101 66.0246Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.221 34.8323L112.894 27.1191C112.376 23.9735 111.067 21.0109 109.091 18.509C107.115 16.007 104.537 14.0475 101.597 12.8139C99.038 11.7909 96.3625 11.0882 93.6311 10.7218C90.1259 10.2323 85.2153 10.7218 79.7206 12.1665C56.0522 18.3797 38.6837 38.4323 35.0916 62.606L33.5127 73.3034L72.4417 76.0113C72.4417 76.0113 70.468 64.9586 84.2838 64.9586C98.0996 64.9586 115.594 65.1007 114.221 34.8323Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M76.0732 22.8718C76.0732 22.8718 57.1811 26.1955 36.418 56.1166L33.5127 73.3034L63.0548 75.4982L76.0732 22.8718Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7374 36.6324C101.424 24.3324 87.1269 14.385 76.9347 22.2008C68.4084 28.7298 58.7769 40.485 58.3979 60.3245C57.7426 96.1272 92.0374 89.7245 138.451 76.0114L136.974 65.5824C136.974 65.5824 81.3953 76.0903 88.9427 58.0272C92.1005 50.4719 95.7795 43.1772 97.7374 36.6324Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.7374 36.6324C101.424 24.3324 87.1269 14.385 76.9347 22.2008C68.4084 28.7298 58.7769 40.485 58.3979 60.3245C57.7426 96.1272 92.0374 89.7245 138.451 76.0114L136.974 65.5824C136.974 65.5824 81.3953 76.0903 88.9427 58.0272C92.1005 50.4719 95.7795 43.1772 97.7374 36.6324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2296 86.906C78.2296 86.906 79.3743 126.498 33.048 133.903L31.2559 125.511C31.2559 125.511 68.3611 116.314 44.3927 91.6744L78.2296 86.906Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M151.2 140.148C153.982 140.148 156.237 139.314 156.237 138.285C156.237 137.256 153.982 136.422 151.2 136.422C148.419 136.422 146.164 137.256 146.164 138.285C146.164 139.314 148.419 140.148 151.2 140.148Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M170.462 135.324C173.244 135.324 175.499 134.49 175.499 133.461C175.499 132.432 173.244 131.598 170.462 131.598C167.68 131.598 165.425 132.432 165.425 133.461C165.425 134.49 167.68 135.324 170.462 135.324Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.86 139.051C192.642 139.051 194.897 138.216 194.897 137.187C194.897 136.158 192.642 135.324 189.86 135.324C187.078 135.324 184.823 136.158 184.823 137.187C184.823 138.216 187.078 139.051 189.86 139.051Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M219.561 140.922C222.343 140.922 224.598 140.088 224.598 139.059C224.598 138.03 222.343 137.196 219.561 137.196C216.779 137.196 214.524 138.03 214.524 139.059C214.524 140.088 216.779 140.922 219.561 140.922Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M132.103 134.906C134.946 134.906 137.251 134.05 137.251 132.995C137.251 131.94 134.946 131.085 132.103 131.085C129.261 131.085 126.956 131.94 126.956 132.995C126.956 134.05 129.261 134.906 132.103 134.906Z",
    fill: "#668099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.257 67.5873C137.257 67.5873 150.031 66.2373 151.152 71.2268C152.273 76.2163 149.826 78.861 138.331 75.1742L137.257 67.5873Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.002 67.4217C10.002 67.4217 11.8414 74.8743 19.2072 73.3032C26.573 71.7322 21.3151 62.5901 10.002 67.4217Z",
    fill: "#F4A28C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4184_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 239.999,
    height: 154,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAvailable);
export default __webpack_public_path__ + "static/media/notAvailable.861ae756c5547b7654b51d2b029bef58.svg";
export { ForwardRef as ReactComponent };